import(/* webpackMode: "eager", webpackExports: ["message","success","error"] */ "__barrel_optimize__?names=message!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@ant-design/icons/es/components/AntdIcon.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Blogs/BlogArticle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Home/banner.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/homeComponent/FreshBlog.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/homeComponent/How.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/homeComponent/Logos.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/homeComponent/NewCate.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/homeComponent/Reviews.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/homeComponent/SelectedProducts.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/homeComponent/ToHelp.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/homeComponent/Video.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/homeComponent/WeServer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/homeComponent/Why.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialShare"] */ "/app/src/components/Other/Share.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Social/FollowUs.tsx");
